import React, { Component } from 'react'
import FirstViewlist from '../firstviewlist'
import * as styles from './firstview.module.css'

export default class FirstView extends Component {

  render() {
    return (
      <div className={styles.firstview}>
        <p className={styles.firstview_h2}>おすすめ記事 ＆ ピックアップ記事</p>
        <div className={styles.firstview_contents}>
          {/* １列目 */}
          <FirstViewlist target={'titifuckactress'} />
          <FirstViewlist target={'titifuckbest'} />
          <FirstViewlist target={'debut'} />
          <FirstViewlist target={'pzyear'} />
          {/* ２列目 */}
          <FirstViewlist target={'compilation'} />
          <FirstViewlist target={'titifuckseries'} />
          <FirstViewlist target={'bbb'} />
          <FirstViewlist target={'mitsuitowa-page-1'} />
          {/* ３列目 */}
          <FirstViewlist target={'sayamaai'} />
          <FirstViewlist target={'tanakanene'} />
          <FirstViewlist target={'himari'} />
          <FirstViewlist target={'mizuharamisono'} />
          {/* 5/20 23:59 */}
          {/*
          <FirstViewlist target={'bomn00054'} />
          <FirstViewlist target={'bomn00098'} />
          <FirstViewlist target={'bomn00116'} />
          <FirstViewlist target={'bomn00078'} />
          */}
          {/* ４列目 */}
          <FirstViewlist target={'fuzoku'} />
          <FirstViewlist target={'titifuckvr'} />
          <FirstViewlist target={'fc2ppv'} />
          <FirstViewlist target={'avbest'} />
        </div>
      </div>
    )
  }
}